import styled from "styled-components";
import { Tab } from "@renderbus/ui";
import { useGetTabsList } from "./hooks/useInitTableList";
import {
  InvoiceStoreContainerProvider,
  useInvoiceStore,
} from "./store/invoice-store";
import { InoviceTabType } from "./constants";
import { InvoiceTip } from "./components/invoice-tips";

export function InoviceView() {
  const { tabsList, setCurrentInvoiceTab, currentInvoiceTab } =
    useGetTabsList();
  const { showInvoiceTip } = useInvoiceStore();
  const isInvoicing = currentInvoiceTab === InoviceTabType.BiilableRecord;
  return (
    <InvoiceWrapper openInvoice={isInvoicing && showInvoiceTip}>
      <Tab
        tabsList={tabsList}
        onChange={(key) => setCurrentInvoiceTab(key as InoviceTabType)}
      />
      {isInvoicing && <InvoiceTip />}
    </InvoiceWrapper>
  );
}

export default function Inovice() {
  return (
    <InvoiceStoreContainerProvider>
      <InoviceView />
    </InvoiceStoreContainerProvider>
  );
}

const InvoiceWrapper = styled.div<{ openInvoice: boolean }>`
  display: flex;
  gap: 16px;
  height: calc(100% - 22px);
  .renderbus-ui-tab {
    box-sizing: border-box;
    flex-grow: 1;
    width: auto;
    max-width: ${(p) => (p.openInvoice ? "calc(100% - 386px)" : "100%")};
  }
`;
